<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.xs"
    :max-width="$vuetify.breakpoint.xs ? undefined : '95vw'"
    scrollable
  >
    <v-card v-if="producto">

      <!-- TÍTULO -->
      <v-card-title
        class="font-weight-bold pa-4"
        style="font-size: 18px; color: #333; display: flex; justify-content: space-between; align-items: center;"
      >
        {{ producto.descripcion }}
        <v-btn icon small @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text class="pa-4">
        <v-row>

          <!-- IMAGEN -->
          <v-col cols="12" md="6" class="d-flex justify-center align-start">
            <div style="width: 100%; overflow: hidden; border-radius: 8px; background: #f5f5f5;">
              <img
                :src="serverUrl + 'api/productos/get_img_unico_producto/' + producto.id + '/' + producto.link_photo"
                :style="{
                  width: '100%',
                  height: $vuetify.breakpoint.xs ? '250px' : '480px',
                  objectFit: 'contain',
                  transform: 'scale(' + ((producto.zoom || 50) / 50) + ') translate(' + producto.fotox + 'px,' + producto.fotoy + 'px)',
                  transition: 'transform 0.2s'
                }"
              />
            </div>
          </v-col>

          <!-- DATOS -->
          <v-col cols="12" md="6">

            <!-- PRECIO -->
            <div class="mb-3">
              <span style="font-size: 22px; font-weight: 700; color: #8B0000;">
                Gs. {{ formatearPrecio(producto.pvu) }}
              </span>
              <span v-if="producto.pvu2" class="ml-3 grey--text" style="font-size: 14px;">
                Mayorista: Gs. {{ formatearPrecio(producto.pvu2) }}
              </span>
            </div>

            <!-- STOCK -->
            <div class="mb-3">
              <div v-if="producto.cantidad_total <= 0" class="red--text d-flex align-center">
                <v-icon small class="mr-1 red--text">mdi-cancel</v-icon>
                Stock Agotado
              </div>
              <div v-else class="green--text d-flex align-center">
                <v-icon small class="mr-1 green--text">mdi-check-circle-outline</v-icon>
                Disponible
              </div>
            </div>

            <!-- SUB1 -->
            <div v-if="producto.sub1" class="mb-1" style="font-size: 14px; color: #555;">
              {{ producto.sub1 }}
            </div>

            <!-- SUB2 -->
            <div v-if="producto.sub2" class="mb-1" style="font-size: 13px; color: #777;">
              {{ producto.sub2 }}
            </div>

            <!-- SUB3 -->
            <div v-if="producto.sub3" class="mb-1" style="font-size: 13px; color: #777;">
              {{ producto.sub3 }}
            </div>

            <!-- CATEGORÍA -->
            <div v-if="producto.categoria" class="mb-1" style="font-size: 13px;">
              <span class="font-weight-bold">Categoría:</span> {{ producto.categoria.descripcion }}
            </div>

            <!-- VENDEDOR -->
            <div v-if="producto.vendedor" class="mb-3" style="font-size: 13px;">
              <span class="font-weight-bold">Vendedor:</span>
              {{ producto.vendedor.nombre }} {{ producto.vendedor.apellido }}
            </div>

            <!-- CANTIDAD -->
            <v-col cols="12" class="mt-2 pa-0">
              <v-text-field
                v-model.number="cantidadAgregar"
                label="Cantidad"
                type="number"
                min="1"
                :max="producto ? producto.cantidad_total : 1"
                outlined dense
                hide-details
                :disabled="!producto || producto.cantidad_total <= 0"
                style="max-width: 120px;"
              ></v-text-field>
            </v-col>

            <!-- BOTONES -->
            <v-row no-gutters class="mt-3">
              <v-col cols="12" class="mb-2">
                <v-btn
                  outlined
                  color="green darken-2"
                  style="text-transform: none; width: 100%;"
                  @click="openConsultar"
                >
                  <v-icon left>mdi-whatsapp</v-icon>
                  Consultar por WhatsApp
                </v-btn>
              </v-col>
              <v-col cols="12">
                <v-btn
                  outlined
                  color="blue darken-4"
                  style="text-transform: none; width: 100%;"
                  @click="perfilOpen"
                >
                  <v-icon left>mdi-account</v-icon>
                  Ir al perfil del vendedor
                </v-btn>
              </v-col>

              <v-col cols="12" class="mt-2">
                <v-btn
                  outlined
                  :color="stockAgotado ? 'grey' : 'orange darken-2'"
                  style="text-transform: none; width: 100%;"
                  :disabled="stockAgotado"
                  @click="agregarAlCarrito"
                >
                  <v-icon left>{{ stockAgotado ? 'mdi-cancel' : 'mdi-cart-plus' }}</v-icon>
                  {{ stockAgotado ? 'Stock Agotado' : 'Agregar al carrito' }}
                </v-btn>
              </v-col>

              <!-- Botones post-agregar -->
              <v-col cols="12" class="mt-2">
                <v-btn outlined color="primary" style="text-transform: none; width: 100%;" class="mb-2" @click="dialog = false">
                  <v-icon left>mdi-store</v-icon>
                  Seguir comprando
                </v-btn>
                <v-btn outlined color="orange darken-2" style="text-transform: none; width: 100%;" @click="irAlCarrito">
                  <v-icon left>mdi-cart</v-icon>
                  Ir al Carrito
                </v-btn>
              </v-col>
            </v-row>

          </v-col>
        </v-row>

        <!-- INFO DETALLADA -->
        <v-row v-if="producto.info" class="mt-2">
          <v-col cols="12">
            <v-divider class="mb-3"></v-divider>
            <div class="font-weight-bold mb-1" style="font-size: 14px; color: #78909C;">
              Información Detallada
            </div>
            <div style="font-size: 13px; color: #444; white-space: pre-line;">
              {{ producto.info }}
            </div>
          </v-col>
        </v-row>

      </v-card-text>

    </v-card>

    <!-- SNACKBAR DE CONFIRMACIÓN -->
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :timeout="3000"
      top
    >
      {{ snackbarTexto }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">Cerrar</v-btn>
      </template>
    </v-snackbar>
  </v-dialog>
</template>

<script>
export default {
  name: 'DetalleProductoDialog',

  props: {
    value: {
      type: Boolean,
      default: false
    },
    producto: {
      type: Object,
      default: null
    },
    serverUrl: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      cantidadAgregar: 1,
      snackbar: false,
      snackbarTexto: '',
      snackbarColor: 'success'
    };
  },

  watch: {
    value(val) {
      if (val) {
        // Resetear cantidad a 1 cuando se abre el diálogo
        this.cantidadAgregar = 1;
      }
    },
    producto() {
      this.cantidadAgregar = 1;
    }
  },

  computed: {
    dialog: {
      get() { return this.value; },
      set(v) { this.$emit('input', v); }
    },
    stockAgotado() {
      return !this.producto || parseInt(this.producto.cantidad_total) <= 0;
    }
  },

  methods: {
    formatearPrecio(valor) {
      if (!valor) return '0';
      return Math.floor(valor)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },

    openConsultar() {
      if (!this.producto || !this.producto.vendedor) return;
      const numero = this.producto.vendedor.celular;
      const imagenUrl = `${this.serverUrl}api/productos/get_img_unico_producto/${this.producto.id}/${this.producto.link_photo}`;
      const mensaje =
        `Hola, quiero consultar sobre este producto:\n\n` +
        ` *${this.producto.descripcion}*\n` +
        ` *Precio:* Gs. ${this.formatearPrecio(this.producto.pvu)}\n` +
        ` *Detalle:* ${this.producto.sub1}\n` +
        ` *Imagen:* ${imagenUrl}\n\n` +
        `¿Podrías darme más información, por favor?`;
      window.open(`https://wa.me/${numero}?text=${encodeURIComponent(mensaje)}`, '_blank');
    },

    perfilOpen() {
      if (!this.producto || !this.producto.vendedor) return;
      const url = this.$router.resolve({
        path: `/perfil/${this.producto.vendedor.identificador}`
      }).href;
      window.open(url, '_blank');
    },

    agregarAlCarrito() {
      if (!this.producto || parseInt(this.producto.cantidad_total) <= 0) return;

      const maxStock = parseInt(this.producto.cantidad_total);
      let cantidadFinal = this.cantidadAgregar;
      let fueClampeado = false;

      // Clampear cantidad al rango [1, stock]
      if (cantidadFinal < 1 || isNaN(cantidadFinal)) {
        cantidadFinal = 1;
        this.cantidadAgregar = 1;
      }
      if (cantidadFinal > maxStock) {
        cantidadFinal = maxStock;
        this.cantidadAgregar = maxStock;
        fueClampeado = true;
      }

      // Detectar si ya está en el carrito
      const yaEnCarrito = this.$store.state.carrito.find(
        item => item.producto.id === this.producto.id
      );

      // Commit al store
      this.$store.commit('agregarAlCarrito', { producto: this.producto, cantidad: cantidadFinal });

      // Mostrar snackbar según caso
      if (fueClampeado) {
        // Warning: cantidad clampeada al stock máximo
        this.snackbarTexto = `Cantidad ajustada al máximo disponible: ${maxStock} unidad(es)`;
        this.snackbarColor = 'warning';
      } else if (yaEnCarrito) {
        // Info: unidades sumadas a item existente
        this.snackbarTexto = `Se sumó +${cantidadFinal} unidad(es) al carrito (producto ya agregado)`;
        this.snackbarColor = 'info';
      } else {
        // Success: nuevo item agregado
        this.snackbarTexto = `Producto agregado al carrito (${cantidadFinal} unidad/es)`;
        this.snackbarColor = 'success';
      }
      this.snackbar = true;
    },

    irAlCarrito() {
      this.dialog = false;
      this.$router.push('/store-carrito').catch(() => {});
    }
  }
};
</script>
